import { FC } from "react";
import { Box, TextField, MenuItem, IconButton, Tooltip, Select, InputLabel, FormControl } from "@mui/material";
import { IInvoicePosition } from "../../../InvoicePage";

interface InvoicePositionItemProps {
    key: string;
    index: number;
    position: IInvoicePosition;
    onChange: (index: number, field: keyof IInvoicePosition, value: any) => void;
    onDelete: (index: number) => void;
    producers?: string[] | null;
}

const vatOptions = [
    { value: 23, label: "23%" },
    { value: 8, label: "8%" },
];

const InvoicePositionsItem: FC<InvoicePositionItemProps> = ({
    key,
    index,
    position,
    onChange,
    onDelete,
    producers
}) => {
    const { name, description, quantity, grossPrice, vat = 23 } = position;
    const valueBrutto = Number(quantity) * Number(grossPrice);

    return (
        <Box
            key={key}
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                background: "#fff",
                borderRadius: 1,
                px: 2,
                py: 1,
                boxShadow: "0 1px 6px 0 rgba(0,128,0,0.04)",
                fontSize: 15,
                flexWrap: "wrap",
            }}
        >
            <FormControl sx={{ width: '200px' }}>
                <InputLabel id="demo-simple-select-label">Producent</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Producent"
                    value={position.producer}
                >
                    {producers && producers.map((producer, idx) => (
                        <MenuItem
                            key={idx}
                            value={producer}
                            onClick={() => onChange(index, "producer", producer)}
                        >
                            {producer}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <TextField
                value={name}
                onChange={e => onChange(index, "name", e.target.value)}
                variant="outlined"
                placeholder="Nazwa mebla"
                label="Nazwa"
                sx={{
                    width: 230,
                    minWidth: 180,
                    fontWeight: 500,
                    background: "#f9f9f9",
                }}
                multiline
                maxRows={30}
                inputProps={{ style: { whiteSpace: "pre-wrap" } }}
            />
            <TextField
                value={description}
                onChange={e => onChange(index, "description", e.target.value)}
                variant="outlined"
                label="Opis"
                placeholder="Opis"
                sx={{
                    width: 320,
                    minWidth: 320,
                    background: "#f9f9f9",
                }}
                multiline
                maxRows={30}
                inputProps={{ style: { whiteSpace: "pre-wrap" } }}
            />
            <TextField
                value={quantity}
                onChange={e => onChange(index, "quantity", Number(e.target.value))}
                variant="outlined"
                label="Ilość"
                type="number"
                sx={{
                    width: 80,
                    minWidth: 80,
                    textAlign: "center",
                    background: "#f9f9f9",
                }}
                inputProps={{ min: 1, style: { textAlign: "center" } }}
            />
            <TextField
                value={grossPrice}
                onChange={e => onChange(index, "grossPrice", Number(e.target.value))}
                variant="outlined"
                label="Cena brutto"
                type="number"
                sx={{
                    width: 120,
                    minWidth: 120,
                    textAlign: "center",
                    background: "#f9f9f9",
                }}
                inputProps={{ min: 0, step: 0.01, style: { textAlign: "center" } }}
            />
            <TextField
                select
                label="VAT"
                value={vat}
                onChange={e => onChange(index, "vat", Number(e.target.value))}
                variant="outlined"
                sx={{
                    width: 80,
                    minWidth: 80,
                    textAlign: "center",
                    background: "#f9f9f9",
                }}
            >
                {vatOptions.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </TextField>
            <Box
                sx={{
                    width: 120,
                    minWidth: 120,
                    textAlign: "center",
                    fontWeight: 700,
                    color: "#388e3c",
                    fontSize: 16,
                    background: "#e8f5e9",
                    borderRadius: 1,
                    py: 1,
                    overflowWrap: "break-word",
                }}
            >
                {valueBrutto.toFixed(2)} PLN
            </Box>
            <Tooltip title="Usuń pozycję">
                <IconButton
                    color="error"
                    onClick={() => onDelete(index)}
                    sx={{
                        ml: 0,
                        borderRadius: "50%",
                        transition: "background 0.18s, box-shadow 0.18s",
                        "&:hover": {
                            backgroundColor: "#ffebee",
                            borderRadius: "50%",
                        },
                        width: 40,
                        height: 40,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 22,
                    }}
                >
                    ×
                </IconButton>
            </Tooltip>
        </Box>
    );
};

export default InvoicePositionsItem;